import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router の遷移時にスクロールを最上部に戻すコンポーネント。
 * 何もレンダリングせず、useLocation の pathname が変わるたびに window.scrollTo(0,0) を呼ぶ。
 *
 * 同一ページ内のハッシュ遷移（#section）は無視し、pathname が変わったときだけ戻す。
 * もし戻りたくないルート（例：タブ切り替え）があれば preserveScrollFor に列挙する。
 */
const preserveScrollFor: RegExp[] = [
  // 例: /admin/entities/<x>/<page> のような Admin 一覧内ページングは
  // ここに追加すれば最上部スクロールを抑止できる
];

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (preserveScrollFor.some((re) => re.test(pathname))) return;
    // ブラウザの履歴復元と競合しないよう、即時 + 次フレームの 2 段階で戻す。
    window.scrollTo(0, 0);
    requestAnimationFrame(() => window.scrollTo(0, 0));
  }, [pathname]);

  return null;
}

export default ScrollToTop;
